import styled from '@emotion/styled'

export const Cell = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`
